import { styled, Container } from "@mui/material";

export const ContainerStyled = styled(Container)`
  height: 100vh;
`;
